export default __webpack_public_path__ + "static/media/news2.6b2c1557.jpg";